import Vue from 'vue'
import ShowDown from 'showdown'
import _ from 'lodash'
import Constants from '@/constants'
// export const EventBus = new Vue({ el: '#app' }) <-- in this case access using import { EventBus }
export default new Vue({
  data: {
    _navMain: [
      {
        name: 'about',
        label: 'About Us',
        path: '/about'
      }, {
        name: 'services',
        label: 'Services',
        path: '/services'
      }, {
        name: 'links',
        label: 'Helpful Links',
        path: '/links'
      }, {
        name: 'faq',
        label: 'FAQ',
        path: '/faq'
      }, {
        name: 'reports',
        label: 'Web Reports',
        path: '/reports'
      }, {
        name: 'payment',
        label: 'Make A Payment',
        path: '/payment'
      }, {
        name: 'contact',
        label: 'Contact Us',
        path: '/contact'
      }
    ],
    info: {}
  },
  computed: {
    isDesktop: {
      get: function () {
        return this._isDesktop
      },
      set: function (isDesktop) {
        if (this._isDesktop !== isDesktop) {
          // do not update immediately, only change if necessary
          this._isDesktop = isDesktop
          this.$emit('isDesktopChanged', isDesktop)
        }
      }
    }
  },
  watch: {
  },
  mounted () {
    // console.log('-- mounted')
  },
  methods: {
    devMode: function () {
      let url = Constants.BASE_API
      if (url.indexOf('.com') >= 0) {
        return 'production'
      } else if (url.indexOf('localhost') >= 0) {
        return 'development'
      }
      return undefined
    },

    loadImage: function (url) {
      return new Promise((resolve) => {
        let img = new Image()
        img.src = url
        img.onload = () => resolve(img)
      })
    },

    getHtml: function (content) {
      var converter = new ShowDown.Converter()
      var html = converter.makeHtml(content)
      return html
    },

    toggleSubnavOpen: function (name) {
      let navItem = _.find(this._data._navMain, ['name', name])
      if (navItem && navItem.hasOwnProperty('subnavOpen')) {
        navItem.subnavOpen = !navItem.subnavOpen
      }
    },

    getNav: function () {
      return this._data._navMain
    },

    detectIE: function () {
      /**
       * detect IE
       * returns version of IE or false, if browser is not Internet Explorer
       */
      var ua = window.navigator.userAgent

      // Test values; Uncomment to check result …

      // IE 10
      // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

      // IE 11
      // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

      // Edge 12 (Spartan)
      // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

      // Edge 13
      // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

      var msie = ua.indexOf('MSIE ')
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
      }

      var trident = ua.indexOf('Trident/')
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:')
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
      }

      var edge = ua.indexOf('Edge/')
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
      }

      // other browser
      return false
    }
  }
})



// WEBPACK FOOTER //
// ./src/controllers/EventBus.js